import { render, staticRenderFns } from "./CoeDay.vue?vue&type=template&id=63672813&"
import script from "./CoeDay.vue?vue&type=script&lang=js&"
export * from "./CoeDay.vue?vue&type=script&lang=js&"
import style0 from "./CoeDay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/viniazvd/vue-coe-calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63672813')) {
      api.createRecord('63672813', component.options)
    } else {
      api.reload('63672813', component.options)
    }
    module.hot.accept("./CoeDay.vue?vue&type=template&id=63672813&", function () {
      api.rerender('63672813', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CoeDay.vue"
export default component.exports